import React from 'react';
import { isMobile } from 'react-device-detect';
export var ChatIFrame = function (props) {
    var _a;
    var borderRadius = (_a = props.partnerConfig.borderRadius) === null || _a === void 0 ? void 0 : _a.widget;
    var iframeStyle = {
        display: 'flex',
        flex: 1,
        width: isMobile ? '100%' : 375,
        height: '100%',
        minHeight: isMobile ? '100%' : 390,
        maxHeight: isMobile ? '100%' : 700,
        marginTop: 'auto',
        border: 'none',
        boxSizing: 'border-box',
        filter: 'drop-shadow(0px 5px 100px rgba(35, 31, 32, 0.3))',
        borderRadius: borderRadius || 10,
        userSelect: 'none',
        zIndex: 2147483647,
        pointerEvents: 'auto'
    };
    if (isMobile) {
        iframeStyle.position = 'fixed';
        iframeStyle.top = 0;
        iframeStyle.right = 0;
        iframeStyle.borderRadius = 0;
    }
    if (!props.visible) {
        iframeStyle.width = 0;
    }
    return (React.createElement("iframe", { id: "__EDDY_TRAVELS_CHAT_IFRAME", src: props.chatUrl, style: iframeStyle, allow: "clipboard-write; web-share" }));
};
